import {
  get_headers,
  GET_COMPANIES,
  ASSIGN_SERVICES_TO_PROJECT,
  UNASSIGN_SERVICES_TO_PROJECT,
  GET_ASSIGNED_PROJECTS_TO_SERVICE
} from '@/utils/constants/constants.js';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';

export default {
  name: 'VerificationServicesConfigurations',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable
  },
  data: () => ({
      services: [],
      projects: [],
      selected_service: null,
      loading: false,
      error: null,
    }),

  mounted() {
    this.fetch_projects();
    this.fetch_verification_services();
  },

  methods: {
    get_assigned_project_names(service) {
      return this.projects
        .filter(p => service.assigned_projects.includes(p.id))
        .map(p => p.name);
    },

    is_project_assigned(project_id) {
      return this.selected_service?.assigned_projects.includes(project_id);
    },

    fetch_verification_services() {
      axios.get(GET_ASSIGNED_PROJECTS_TO_SERVICE, { headers: get_headers() })
        .then(res => {
          const parsed = typeof res.data === "string" ? JSON.parse(res.data) : res.data;

          if (parsed.status === 'success' && parsed.data) {
            this.services = parsed.data.map(service => ({
              id: service.id,
              name: service.name,
              description: service.description,
              price: service.price ?? "",
              assigned_projects: service.assigned_projects
            }));
          } else {
            this.show_error(parsed.message || "Failed to load services");
          }
        })
        .catch(() => {
          this.show_error("Failed to load verification services");
        });
    },

    fetch_projects() {
      axios.get(GET_COMPANIES, {
        headers: get_headers()
      }).then(res => {
          const parsed = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          if (parsed.data?.length) {
            this.projects = parsed.data.map(project => ({
              id: project.id,
              name: project.name
            }));
          } else {
            this.show_error("No projects found");
          }
        })
        .catch(() => {
          this.show_error("Error fetching projects");
        });
    },


    assign_project_to_service(id) {
      axios.post(
        ASSIGN_SERVICES_TO_PROJECT,
        {
          service_id: this.selected_service.id,
          project_id: id
        },
        { headers: get_headers() }
      )
        .then(() => {
          if (!this.selected_service.assigned_projects.includes(id)) {
            this.selected_service.assigned_projects.push(id);
          }

          this.show_success("Project assigned successfully");
        })
        .catch(() => {
          this.show_error("Failed to assign project");
        });
    },


    unassign_project_from_service(id) {
      axios.post(
        UNASSIGN_SERVICES_TO_PROJECT,
        {
          service_id: this.selected_service.id,
          project_id: id
        },
        { headers: get_headers() }
      )
        .then(() => {
          this.selected_service.assigned_projects =
            this.selected_service.assigned_projects.filter(pid => pid !== id);

          this.show_success("Project unassigned successfully");
        })
        .catch(() => {
          this.show_error("Failed to unassign project");
        });
    },


    handle_toggle_project(project_id) {
      if (this.is_project_assigned(project_id)) {
        this.unassign_project_from_service(project_id);
      } else {
        this.assign_project_to_service(project_id);
      }
    }
  }
};
